export enum PbxMode {
    ALWAYS_PRESENT = 1,
    ALWAYS_ABSENT = 2,
    ALWAYS_PRESENT_WITH_REDIRECTION = 3,
    SCHEDULED_ABSENCE = 4
}
